<template>
  <transition name="notification-slide">
    <div
      v-if="notificationStore.isVisible"
      class="global-notification"
      :class="`notification-${notificationStore.type}`"
      @click="notificationStore.hideNotification()"
    >
      <div class="notification-icon">
        <IconSvg
          v-if="notificationStore.type === 'error'"
          name="triangle-exclamation-solid-full"
          size="md"
        />
        <IconSvg
          v-else-if="notificationStore.type === 'success'"
          name="check-solid-full"
          size="md"
        />
        <IconSvg
          v-else-if="notificationStore.type === 'warning'"
          name="triangle-exclamation-solid-full"
          size="md"
        />
        <IconSvg v-else name="circle-info-solid-full" size="md" />
      </div>
      <div class="notification-content">
        <p>{{ notificationStore.message }}</p>
      </div>
      <button
        class="notification-close"
        @click.stop="notificationStore.hideNotification()"
      >
        ×
      </button>
    </div>
  </transition>
</template>

<script>
import { useNotificationStore } from "@/store/notification-store";
import IconSvg from "@/components/IconSvg.vue";

export default {
  components: {
    IconSvg,
  },
  name: "GlobalNotification",
  setup() {
    const notificationStore = useNotificationStore();
    return { notificationStore };
  },
};
</script>

<style scoped>
.global-notification {
  position: fixed;
  top: 20px;
  right: 20px;
  min-width: 300px;
  max-width: 500px;
  padding: 16px 20px;
  background: var(--color-surface);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: flex-start;
  gap: 12px;
  z-index: 10000;
  cursor: pointer;
  transition: all 0.3s ease;
}

.global-notification:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  transform: translateY(-2px);
}

.notification-error {
  border-left: 4px solid #f44336;
}

.notification-success {
  border-left: 4px solid #4caf50;
}

.notification-warning {
  border-left: 4px solid #ff9800;
}

.notification-info {
  border-left: 4px solid #2196f3;
}

.notification-icon {
  font-size: 24px;
  flex-shrink: 0;
}

.notification-content {
  flex: 1;
  margin-top: 2px;
}

.notification-content p {
  margin: 0;
  color: #333;
  font-size: 14px;
  line-height: 1.5;
}

.notification-close {
  background: none;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: color 0.2s;
}

.notification-close:hover {
  color: #333;
}

/* アニメーション */
.notification-slide-enter-active,
.notification-slide-leave-active {
  transition: all 0.3s ease;
}

.notification-slide-enter-from {
  transform: translateX(100%);
  opacity: 0;
}

.notification-slide-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

/* レスポンシブ対応 */
@media (max-width: 640px) {
  .global-notification {
    top: 10px;
    right: 10px;
    left: 10px;
    min-width: auto;
    max-width: none;
  }
}
</style>
